var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"border rounded-sm border-secondary mb-3"},[_c('div',{staticClass:"item-link typo-body-2 d-flex px-3 py-4 text-decoration-none"},[_c('div',{staticClass:"item-info"},_vm._l((_vm.categories),function(category){return _c('div',{key:category.id},[_vm._v(" "+_vm._s(category.text)+" ")])}),0),_c('div',{staticClass:"item-actions"},[_c('span',{staticClass:"item-fee"},[_vm._v(_vm._s(_vm.formatFee))]),_c('router-link',{staticClass:"icon-edit",attrs:{"to":{
					name: 'ShippingCategoryAdditionalFeeEdit',
					params: {
						shippingMethodId: _vm.data.shippingMethodId,
						categoryAdditionalFeeId: _vm.data.id
					}
				}}},[_c('CIcon',{attrs:{"name":"cil-pencil"}})],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }